import React, { useState } from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';

import Modal from '../../Modal.jsx';

const regex = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;

const BtnYoutube = ({
  editor,
}) => {
  const [selection, setSelection] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [link, setLink] = useState('');
  let [,, yId] = link.match(regex) || [];

  if (link && !yId && link.match(/[a-z0-9_-]{11}/i)) {
    yId = link;
  }

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="p-4"
      >
        <h4
          className="text-center display-4"
          style={{ color: '#ff0000' }}
        >
          <FA icon={faYoutube} />
        </h4>

        <div className="form-group">
          <label>Video Link or ID</label>
          <div className="input-group">
            <input
              className="form-control"
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
            <div className="input-group-append">
              <button
                type="button"
                className="btn btn-outline-primary"
                disabled={!yId}
                onClick={() => {
                  editor.insertEmbed(
                    selection,
                    'youtube',
                    yId,
                    'user',
                  );
                  setShowModal(false);
                }}
              >
                <FA icon={faCheck} />
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <button
        type="button"
        onClick={() => {
          const { index = 0 } = editor.getSelection() || {};

          setSelection(index);
          setLink('');
          setShowModal(true);
        }}
      >
        <FA icon={faYoutube} size="xs" />
      </button>
    </>
  );
};

export default BtnYoutube;
